var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-377ee0ad-c9a8-4a14-bb73-0b2f099dd6b7",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-f4dc709f-c0b5-4941-9f1d-7ae65181de6c {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-f4dc709f-c0b5-4941-9f1d-7ae65181de6c",
    d: "M19.83,10.07c0-.55-.45-1-1-1h-5.67c-.55,0-1,.45-1,1v9.27s0,0,0,.01c0,.09.03.17.05.25.01.04.01.09.03.13.01.03.03.05.05.07.05.09.1.18.17.25,0,0,0,0,0,0l2.86,2.72c.06.06.13.09.19.12.04.02.08.06.12.08.12.05.25.07.37.07s.26-.03.38-.08c.04-.02.07-.05.11-.07.07-.04.15-.07.21-.13l2.81-2.72s0,0,0,0c.09-.08.15-.19.2-.3,0,0,.01-.02.02-.02.01-.02,0-.05.02-.08.03-.1.06-.2.06-.3,0,0,0,0,0,0v-9.27ZM16.02,20.67l-1.85-1.76v-7.84h3.67v7.84l-1.82,1.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.53abcfe3f8c74f6b45d3499dcfac4ce2.svg";
export { ForwardRef as ReactComponent };